import {UpsellDialogEntryPoint} from '@Libraries/upsell-dialog.library';
import {openSocialAccountsUpsellDialog, startAccountConnection} from '@Libraries/social-media-account.library';
import type {ComponentAction, ComponentActionDoneHandler, ComponentActionSession, ComponentActionTarget} from './component-action.types';
import {ComponentActionType} from './component-action.types';
import {getTargetPlatform, listenForSocialAccountConnections} from './social-account-action.library';

const openConnectSession = (onDone: ComponentActionDoneHandler): ComponentActionSession => {
  const listener = listenForSocialAccountConnections(onDone);

  return {
    start: (target: ComponentActionTarget): void => {
      const platform = getTargetPlatform(target);
      if (platform === null) {
        return;
      }

      listener.recordStart(target, platform);
      startAccountConnection(platform, (): void => {
        listener.markConnected(target);
      });
    },
    close: listener.close,
  };
};

export const connectSocialAccountAction: ComponentAction = {
  actionType: ComponentActionType.CONNECT_SOCIAL_ACCOUNT,
  openSession: openConnectSession,
  resumePromptFor: (target): string => window.i18next.t('pmwjs_ai_chat_social_platform_connected', {platformName: target.label}),
  doneLabelKey: 'pmwjs_ai_chat_social_account_connected_status',
  openUpgrade: (): void => {
    openSocialAccountsUpsellDialog(UpsellDialogEntryPoint.AI_CHAT_CONNECT_ACCOUNT);
  },
};
